var map = {
	"./1809141.png": 94017,
	"./999.png": 52844,
	"./DCaaS_web_icon_02.png": 44653,
	"./DCasS.png": 94869,
	"./Ellipse 11.png": 27547,
	"./FB.png": 963,
	"./Group 1927.png": 9559,
	"./Group 2141.png": 14134,
	"./Group 2259.png": 42742,
	"./Group 2288.png": 65728,
	"./Group 2297.png": 86076,
	"./Group 2304.png": 88997,
	"./Group 2311.png": 24207,
	"./Group 2318.png": 5230,
	"./Group 2325.png": 76682,
	"./Group 2332.png": 55742,
	"./Icon awesome-archive.png": 72972,
	"./Icon awesome-chalkboard-teacher.png": 60762,
	"./Icon awesome-hands-helping.png": 51640,
	"./Icon awesome-paper-plane.png": 34633,
	"./Icon feather-share-2.png": 13510,
	"./Icon ionic-ios-contract.png": 77531,
	"./Icon ionic-ios-people.png": 8008,
	"./Icon material-center-focus-weak.png": 97339,
	"./Icon metro-shareable.png": 85729,
	"./Image 3.png": 6919,
	"./LinkedIn1.png": 20192,
	"./Rectangle 3.png": 47319,
	"./address.png": 49499,
	"./analytics (1).png": 92529,
	"./analytics (2).png": 13076,
	"./analytics (3).png": 31579,
	"./analytics (4).png": 66774,
	"./analytics.png": 92067,
	"./banner_slide1.jpg": 8570,
	"./banner_slide2.jpg": 31173,
	"./banner_slide3.jpg": 4008,
	"./banner_slide4.jpg": 34011,
	"./bbl.png": 36443,
	"./buy1.jpg": 93422,
	"./buy1.png": 41194,
	"./buy10.jpg": 44052,
	"./buy10.png": 96272,
	"./buy11.jpg": 38929,
	"./buy12.jpg": 81158,
	"./buy12.png": 44994,
	"./buy13.jpg": 45859,
	"./buy13.png": 66123,
	"./buy14.jpg": 31056,
	"./buy16.jpg": 26018,
	"./buy17.jpg": 46015,
	"./buy17.png": 39119,
	"./buy18.jpg": 18268,
	"./buy18.png": 71640,
	"./buy2.jpg": 92089,
	"./buy2.png": 90177,
	"./buy3.jpg": 47740,
	"./buy3.png": 17464,
	"./buy4.jpg": 18503,
	"./buy5.jpg": 6346,
	"./buy5.png": 7086,
	"./buy6.jpg": 46837,
	"./buy6.png": 25861,
	"./buy7.jpg": 85656,
	"./buy7.png": 91996,
	"./comingsoon.jpg": 84755,
	"./comingsoon.png": 78491,
	"./comingsoon2.jpg": 51193,
	"./comingsoon3.jpg": 6844,
	"./contactusBG.jpg": 69046,
	"./contactusBG1.jpg": 88681,
	"./control.png": 9628,
	"./convenience.png": 12562,
	"./dashboard01.png": 61110,
	"./dashboard02.png": 68141,
	"./dcaas seo.jpg": 27064,
	"./doc-control01.png": 17988,
	"./doc-control02.png": 54847,
	"./doc-record01.png": 92666,
	"./doc-record02.png": 68913,
	"./document-901.png": 76223,
	"./documents.png": 60033,
	"./download.png": 355,
	"./email.png": 94931,
	"./facebook.png": 97359,
	"./fb1.png": 70210,
	"./file-Gg16peN6w9.png": 81094,
	"./forgotpassword1.png": 27960,
	"./forgotpassword2.png": 73715,
	"./forgotpassword3.png": 18506,
	"./forgotpassword4.png": 1733,
	"./forgotpassword6.png": 76951,
	"./forgotpassword7.png": 31374,
	"./forgotpassword8.png": 63289,
	"./free1.png": 49412,
	"./free2.png": 86271,
	"./free3.png": 89334,
	"./free4.png": 29417,
	"./general1.png": 34226,
	"./general10.png": 32776,
	"./general11.png": 89073,
	"./general12.png": 64410,
	"./general13.png": 85987,
	"./general14.png": 55820,
	"./general15.png": 38709,
	"./general2.png": 98761,
	"./general3.png": 74560,
	"./general6.png": 80557,
	"./general7.png": 964,
	"./general8.png": 1155,
	"./general9.png": 11322,
	"./home1.png": 11717,
	"./home2.png": 92942,
	"./icon1.png": 68595,
	"./icon2.png": 94104,
	"./icon3.png": 78721,
	"./image1.png": 25927,
	"./keyfeaturesBG.jpg": 27622,
	"./line.png": 45429,
	"./line1.png": 40040,
	"./linkedin.png": 21661,
	"./login1.jpg": 35935,
	"./login1.png": 12687,
	"./login2.jpg": 4624,
	"./login2.png": 93780,
	"./login3.jpg": 48077,
	"./login3.png": 14909,
	"./login4.jpg": 54726,
	"./login5.jpg": 35779,
	"./login6.jpg": 33972,
	"./login7.jpg": 12497,
	"./login8.jpg": 92970,
	"./login8.png": 93710,
	"./login9.jpg": 15623,
	"./login9.png": 36727,
	"./logindcaas1.png": 31541,
	"./logindcaas10.png": 19889,
	"./logindcaas11.png": 87848,
	"./logindcaas12.png": 49827,
	"./logindcaas2.png": 64190,
	"./logindcaas3.png": 82503,
	"./logindcaas4.png": 7336,
	"./logindcaas5.png": 5201,
	"./logindcaas6.png": 91386,
	"./logindcaas7.png": 92611,
	"./logindcaas8.png": 34948,
	"./logindcaas9.png": 74893,
	"./loginiso1.png": 52460,
	"./loginiso2.png": 37287,
	"./loginiso3.png": 49598,
	"./loginiso4.png": 85713,
	"./loginiso5.png": 45768,
	"./loginiso6.png": 82627,
	"./loginiso7.png": 77402,
	"./loginiso8.png": 64909,
	"./logo.png": 20678,
	"./mc_symbol_opt_73_3x.png": 22215,
	"./module-bg.png": 48659,
	"./monitor-01.png": 63129,
	"./monitor-02.png": 80194,
	"./packageplus1.png": 6642,
	"./packageplus2.png": 37609,
	"./packageplus3.png": 43136,
	"./packageplus4.png": 94463,
	"./packagepluspaylater1.png": 53722,
	"./packagepluspaylater2.png": 62033,
	"./packagepluspaylater4.png": 13607,
	"./packagepluspaylater5.png": 25918,
	"./packagepluspaylater6.png": 11669,
	"./paperless.png": 68602,
	"./paylater1.png": 17282,
	"./paylater3.png": 99184,
	"./paylater5.png": 26310,
	"./payment1.png": 41140,
	"./payment2.png": 63599,
	"./payment3.png": 78502,
	"./payment4.png": 83481,
	"./payment5.png": 67728,
	"./payment6.png": 33131,
	"./pexels-andrea-01.png": 24912,
	"./pexels-andrea-02.png": 90315,
	"./pexels-andrea-03.png": 26658,
	"./pexels-andrea-04.png": 19453,
	"./pexels-fauxels-01.png": 32869,
	"./pexels-karolina-01.png": 44042,
	"./pexels-sora-shimazaki-01.png": 20356,
	"./profile.png": 90196,
	"./promtpay.png": 15703,
	"./puzzle.png": 65159,
	"./qr-code.png": 41790,
	"./qrcode.png": 42789,
	"./record.png": 26852,
	"./reset1.jpg": 23157,
	"./reset1.png": 2181,
	"./reset2.jpg": 13258,
	"./reset2.png": 90702,
	"./reset3.jpg": 69095,
	"./reset3.png": 73847,
	"./reset4.jpg": 63100,
	"./reset5.jpg": 67801,
	"./reset6.jpg": 77038,
	"./reset7.jpg": 55083,
	"./reset7.png": 63667,
	"./reset8.jpg": 23472,
	"./reset8.png": 21396,
	"./role.png": 63203,
	"./secure-payment.png": 73925,
	"./secure.png": 74616,
	"./slide1.jpg": 89519,
	"./slide2.jpg": 92256,
	"./slide3.jpg": 27037,
	"./slide4.jpg": 72278,
	"./target.png": 74688,
	"./tasks.png": 85541,
	"./team-1.png": 49670,
	"./team.png": 60088,
	"./telephone.png": 21479,
	"./trading.png": 12152,
	"./upgrade1.png": 44278,
	"./upgrade10.png": 49252,
	"./upgrade11.png": 12493,
	"./upgrade12.png": 97078,
	"./upgrade14.png": 22848,
	"./upgrade15.png": 47049,
	"./upgrade16.png": 82514,
	"./upgrade2.png": 34957,
	"./upgrade3.png": 92452,
	"./upgrade4.png": 2395,
	"./upgrade5.png": 53394,
	"./upgrade8.png": 90983,
	"./upgrade9.png": 3294,
	"./upgrde.png": 70110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;